import { zergApi } from "@/service/zerg";

class AccountingAccountsService {

    async getAccountingAccounts(params) {
        try {
            const data = await zergApi.get("/bookeeping/accounting-accounts/index", { params });
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new AccountingAccountsService();